import React, { useEffect, useState } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
const OurVision = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <div>
            <div class="bg-img">
                <div class="container">
                    <div class="cover-title">
                        <h1>
                            {lang === "Fr"
                                ? `NOTRE VISION, NOTRE MISSION ET NOS VALEURS`
                                : `Our Vision,Mission And Values`}{" "}
                        </h1>
                    </div>
                </div>
            </div>
            <></>
            <section className="ourVision">
                <div
                    className="leftBox"
                    data-aos="fade-down-right"
                    data-aos-duration="1000"
                >
                    <ul>
                        <li>
                            <Link to="/about-us">
                                {lang === "Fr"
                                    ? `À propos de nous`
                                    : `About Us`}
                            </Link>
                        </li>
                        <li>
                            <Link to="/products-services">
                                {lang === "Fr"
                                    ? `Nos Services`
                                    : `Our Services`}
                            </Link>
                        </li>
                    </ul>
                </div>
                <div
                    className="visionContent"
                    data-aos="fade-down"
                    data-aos-duration="1500"
                >
                    {/* <h1>Our Vision,Mission And Values</h1> */}
                    <div className="our-block">
                        <h2>{lang === "Fr" ? `NOTRE VISION` : `Our Vision`}</h2>
                        <p>
                            {lang === "Fr"
                                ? `Être la première société aurifère`
                                : `To be the leading gold company`}
                        </p>
                    </div>
                    <div className="our-block">
                        <h2>
                            {lang === "Fr" ? `NOTRE MISSION` : `Our Mission`}
                        </h2>
                        <p>
                            {lang === "Fr"
                                ? `Créer de la valeur pour nos actionnaires, nos employés et notre entreprise,
ainsi que pour nos partenaires sociaux, en explorant, en exploitant et en
commercialisant nos produits de manière sûre et responsable. Notre objectif
principal est l’or, mais nous poursuivrons des opportunités de création de
valeur dans d’autres minéraux où nous pourrons tirer parti de nos actifs, de
nos compétences et de notre expérience existants pour améliorer la création
de valeur.`
                                : `To create value for our shareholders, our employees
                            and our business, and social partners by safely and
                            responsibly exploring, mining and marketing our
                            products. Our primary focus is gold, but we will
                            pursue value creating opportunities in other
                            minerals where we can leverage our existing assets,
                            skills and experience to enhance the delivery of
                            value.`}
                        </p>
                    </div>
                    <div className="our-block" data-aos="fade-down">
                        <h2>{lang === "Fr" ? `NOS VALEURS` : `Our Values`}</h2>
                        <p>
                            {lang === "Fr"
                                ? `Nos six valeurs guident toutes les décisions prises et les actions prises dans la
conduite de nos affaires. Ces valeurs lient nos activités commerciales à nos
responsabilités environnementales, sociales et de gouvernance (ESG).`
                                : `Our six values guide all decisions made and actions
                            taken in the conduct of our business. These values
                            link our business activities to our environmental,
                            social and governance (ESG) responsibilities.`}
                            <ul>
                                <li>
                                    {lang === "Fr"
                                        ? `La sécurité est notre première valeur.`
                                        : `Safety is our first value.`}
                                </li>
                                <li>
                                    {lang === "Fr"
                                        ? `Nous nous traitons les uns les autres avec dignité et respect.`
                                        : ` We treat each other with dignity and
                                    respect.`}
                                </li>
                                <li>
                                    {lang === "Fr"
                                        ? `Nous sommes responsables de nos actions et nous nous engageons à
respecter nos engagements.`
                                        : `We are accountable for our actions and
                                    undertake to deliver on our commitments.`}
                                </li>
                                <li>
                                    {lang === "Fr"
                                        ? `Nous voulons que les communautés et les sociétés dans lesquelles nous
opérons soient mieux loties pour Gold Bar International qui a été là.`
                                        : `We want the communities and societies in
                                    which we operate to be better off for Gold
                                    Bar International having been there.`}
                                </li>
                                <li>
                                    {lang === "Fr"
                                        ? `Nous valorisons la diversité.`
                                        : `We value diversity.`}
                                </li>
                                <li>
                                    {lang === "Fr"
                                        ? `Le succès de notre entreprise est lié au bien-être de nos employés.`
                                        : `The success of our business is tied to the
                                    well-being of our employees.`}
                                </li>
                            </ul>
                        </p>
                    </div>
                </div>
                <div
                    className="rightBox"
                    data-aos="fade-down-left"
                    data-aos-duration="1000"
                >
                    <h2>{lang === "Fr" ? `CONTACTEZ-NOUS` : `Contact Us`}</h2>
                    <img
                        src="https://makah-madinah.vercel.app/static/media/contact.b67eacc232b7a7e5a404.jpg"
                        alt=""
                        width="190px"
                        height="107px"
                    />
                    <p>
                        {lang === "Fr"
                            ? `Pour nous contacter par email, il vous suffit
de remplir le formulaire ci-dessous.`
                            : `To contact us by email, simply fill in the form below.`}
                    </p>
                    <Link to="/contact-us">
                        {lang === "Fr" ? `Lire La Suite ...` : `Read More ...`}
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default OurVision;
